module.exports = __webpack_public_path__ + "static/media/excelPicklist3.eb1de4e9.png";